exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/partners-graphql.js-WebpackMultiOutput";